import { render } from "./IconClaimsFilled.vue?vue&type=template&id=59c25a4e"
import script from "./IconClaimsFilled.vue?vue&type=script&lang=js"
export * from "./IconClaimsFilled.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__